(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};

    const guidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

    /**
     * The menuscript model for Yumbi Campaigns templates
     * @constructor
     */
    class CampaignMenuscriptTemplate {
        Id = 0;
        MenuScriptGuid = undefined;
        Name = undefined;
        EstimatedDiscount = 0;
        CampaignTemplateId;

        /**
         * @param {CampaignMenuscriptTemplate} campaignMenuscriptTemplate
         * @returns {CampaignMenuscriptTemplate}
         */
        initialiseCampaignMenuscriptTemplate(campaignMenuscriptTemplate) {
            return _.extend(this, campaignMenuscriptTemplate);
        }

        /**
         * @param {ErrorService} errorService
         * @returns {boolean}
         */
        Validate(errorService) {
            let validationPassed = true;

            if (!`${this.Name}`.trim()) {
                errorService.showError('Name Required', null);
                validationPassed = false;
            }

            if (!`${this.MenuScriptGuid}`.trim()) {
                errorService.showError('Menuscript Guid Required', null);
                validationPassed = false;
            } else if (!guidRegex.test(this.MenuScriptGuid)) {
                errorService.showError('Menuscript Guid is not valid', null);
                validationPassed = false;
            }

            if (this.EstimatedDiscount <= 0) {
                errorService.showError('Estimated order discount must be greater than zero', null);
                validationPassed = false;
            }

            return validationPassed;
        }

    }

    window.Dashboard.Models.CampaignMenuscriptTemplate = CampaignMenuscriptTemplate;
})();
